<!--下单-->
<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="row"
          ref="ruleForm3"
          label-width="120px"
          class="demo-ruleForm"
      >
        <!-- 下单 -->
        <div class="check-header">
          <div class="business-shop-info">
            <div class="business-shop-box">
              <div class="shop-name">
                <div style="font-size:19px">七彩星级考级报名</div>
                <!--<div class="shop-phone" style="font-size:14px">{{row.phone}}</div>-->
              </div>
            </div>
            <div class="shop-address">请确认考级信息，选择考级人员提交报名</div>
          </div>
        </div>

        <div style="height: 40px"></div>

        <el-divider>考级信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="时间地点">
              {{ row.province }}{{ row.city }}({{ row.datetitle }})
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="星级">
              {{ starType }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              {{ row.address }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              {{ row.phone }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider v-if="!isSubmit">运动员信息</el-divider>
        <el-form
            v-if="!isSubmit"
            :model="formData"
            ref="ruleForm2"
            label-width="120px"
            class="demo-ruleForm mt10"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="name"
                            :rules="[
      { required: true, message: '姓名不能为空', trigger: 'blur' },
    ]"
              >
                <el-input
                    type="text"
                    placeholder="请填入报名人员姓名"
                    v-model="formData.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="num"
                            v-if="formData.numtype==1"
                            :rules="[
      { required: true,validator: validator.idCard, message: '请输入正确的身份证号', trigger: 'blur'},
    ]"
              >
                <el-input
                    type="text"
                    placeholder="请输入身份证号"
                    v-model="formData.num"
                ></el-input>
              </el-form-item>

              <el-form-item label="护照号" prop="num"
                            v-else
                            :rules="[
      { required: true, message: '护照号不能为空', trigger: 'blur'},
    ]"
              >
                <el-input
                    type="text"
                    placeholder="请输入护照号"
                    v-model="formData.num"

                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="证件类型" prop="numTypeName">
                <el-radio-group v-model="formData.numtype">
                  <el-radio :label="1">身份证</el-radio>
                  <el-radio :label="2">护照</el-radio>
                </el-radio-group>
                <div class="form-label-desc">满14周岁以上不可参与考级</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col class="footer-button">
              <el-button type="primary" @click="submitForm2('ruleForm2')" :loading="saveLoading">下一步
              </el-button>
              <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
            </el-col>
          </el-row>
        </el-form>


        <el-divider v-if="isSubmit">运动员信息确认</el-divider>

        <el-form
            v-if="isSubmit"
            :model="formData"
            ref="ruleForm"
            label-width="140px"
            class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="name"
                            :rules="[
    ]"
              >
                <el-input
                    readonly
                    type="text"
                    placeholder="请填入报名人员姓名"
                    v-model="formData.name"
                ></el-input>
                <div class="form-label-desc mt10">此处填写运动员姓名后将不予修改，须返回上一步重新认证运动员</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件号" prop="num"
                            :rules="[
    ]"
              >
                <el-input
                    readonly
                    type="text"
                    placeholder="请输入身份证号"
                    v-model="formData.num"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" v-if="formData.numtype!=1">
              <el-form-item
                  label="生日"
                  prop="birthday"
                  :rules="[
                { required: true, message: '请选择生日' },
              ]"
              >
                <el-date-picker
                    v-model="formData.birthday"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    :picker-options="{
                      disabledDate(time) {
          return time.getTime() > Date.now();
        },
                    }"
                    placeholder="请选择生日">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="是否连考"
                            :rules="[
    ]">
                <el-switch
                    v-model="formData.is_exam_continue"
                    :active-value="1" :inactive-value="2"
                    @change="onLiankaoChange"
                    active-text="是"
                    inactive-text="否"
                    active-color="#409EFF"
                    inactive-color="#ddd"
                >
                </el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="formData.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="报考星级" prop="grade">
                <el-radio-group v-model="formData.grade">
                  <el-radio :label="item" v-for="item in gradeSelectColumns" :key="item">{{ item }}</el-radio>
                </el-radio-group>
                <div class="form-label-desc">黄星级及黄星级以上，须有近一年内CCA组织的赛事经历；</div>
                <div class="form-label-desc">连考须达到连考条件</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="添加证件照片(2寸)" prop="pic">
                <PicUploader :fileList="formData.pic" :limit="1"></PicUploader>
                <div class="form-label-desc">上传2寸免冠照,此照片用于证书粘贴打印</div>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="衣服尺码" prop="csize"
                            :rules="formData.grade.indexOf('红') != -1 ? [
      { required: true, message: '请输入尺码', trigger: 'blur' },
    ] : []"
              >
                <el-input
                    type="text"
                    placeholder="请输入尺码"
                    v-model="formData.csize"
                ></el-input>
                <div class="form-label-desc mt10 cp" @click="cSizeShow=true">查看衣服尺码表</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="鞋  码" prop="footsize"
                            :rules="formData.grade.indexOf('红') != -1 ? [
      { required: true, message: '请输入鞋码', trigger: 'blur' },
    ] : []"
              >
                <el-input
                    type="text"
                    placeholder="请输入鞋码"
                    v-model="formData.footsize"
                ></el-input>
                <div class="form-label-desc mt10 cp" @click="fSizeShow=true">查看鞋码表</div>
              </el-form-item>
            </el-col>


          </el-row>

          <el-row>
            <el-col class="footer-button">
              <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">下一步
              </el-button>
              <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
            </el-col>
          </el-row>
        </el-form>


        <van-dialog v-model="confirmShow" title="信息核对" show-cancel-button @confirm="onConfirmSubmit()">

          <van-cell-group style="height: 8rem ; overflow-y: scroll">

            <van-field
                v-model="formData.name"
                readonly
                label="姓名"
                input-align="right"
            />

            <van-field
                v-model="formData.num"
                readonly
                label="证件号"
                input-align="right"
            />


            <van-field
                v-model="formData.grade"
                readonly
                label="报考星级"
                input-align="right"
            />


            <van-cell title="证件照片(2寸)" v-if="formData.pic.length>0">
              <img :src="formData.pic[0].url" width="100"/>
            </van-cell>


            <!--<van-field-->
            <!--v-model="formData.height"-->
            <!--readonly-->
            <!--label="身  高"-->
            <!--input-align="right"-->
            <!--/>-->

            <!--<van-field-->
            <!--v-model="formData.weight"-->
            <!--readonly-->
            <!--label="体  重"-->
            <!--input-align="right"-->
            <!--/>-->

            <van-field
                v-model="formData.csize"
                readonly
                label="衣服尺码"
                input-align="right"
            />

            <van-field
                v-model="formData.footsize"
                readonly
                label="鞋  码"
                input-align="right"
            />

            <van-field
                v-model="formData.famliy_name"
                readonly
                label="家长姓名"
                input-align="right"
            />
            <van-field
                v-model="formData.famliy_num"
                readonly
                label="身份证号码"
                input-align="right"
            />
            <van-field
                v-model="formData.phone"
                readonly
                label="联系方式"
                input-align="right"
            />

          </van-cell-group>
        </van-dialog>


        <el-dialog :visible.sync="cSizeShow" title="衣服尺码表">
          <img @click="picShow(key,cSizePicList)" v-for="(pic,key) in cSizePicList" :src="pic" style="width: 100%"/>
        </el-dialog>
        <el-dialog :visible.sync="fSizeShow" title="鞋码表">
          <p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>
          <img :src="fSizePicList[0]" @click="picShow(0,fSizePicList)" style="width: 100%"/>
        </el-dialog>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
      </el-form>

    </div>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.shop-name {
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 27px;
  margin-top: 20px;
  padding: 0 15px;
}

.shop-address {
  height: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 13px;
  margin-top: 5px;
  padding: 10px 15px 20px;
  /*border-bottom: 1px solid rgba(0, 0, 0, .1);*/
}

.delivery-times {
  margin-top: 10px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
}

.business-shop-info {
  /*width: 6.81rem;*/
  /*height: 2.66rem;*/
  border-radius: 7px;
  margin-bottom: 0;
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: -48px;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff center;
  background-size: 10px;
}

.check-header {
  width: 100%;
  height: 200px;
  background: url(../../../assets/images/bg-qcxj-index.png) no-repeat center;
  background-size: 100%;
  position: relative;
}

</style>

<script>
import {Field, Notify, Toast, Popup, Picker, Radio, RadioGroup, Dialog, ImagePreview} from "vant";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

export default {
  name: "ExameApplJoin",
  components: {
    [Field.name]: Field,
    Notify,
    Dialog,
    Radio,
    RadioGroup,
    Popup,
    PicUploader,
    [ImagePreview.Component.name]: ImagePreview.Component,
    Toast,
    Picker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      isSubmit: false,
      loginShow: false,
      cSizeShow: false,
      fSizeShow: false,
      confirmShow: false,
      kaoji_id: this.$route.query.kaoji_id,
      share_id: this.$route.query.share_id,
      gradeColumns: ['红', '橙', '黄', '绿', '青', '蓝', '紫'],
      gradeSelectColumns: ['红', '橙', '黄', '绿', '青', '蓝', '紫'],
      // 红橙、红橙黄、红橙黄绿、橙黄、橙黄绿、黄绿
      gradeLiankaoColumns: ['红', '橙', '黄', '绿', '青', '蓝', '紫', '红橙', '红橙黄', '红橙黄绿', '橙黄', '橙黄绿', '黄绿'],
      cSizePicList: ['https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png', 'https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
      fSizePicList: ['https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
      showGradePicker: false,
      showNumTypePicker: false,
      message: "",
      formData: {
        needLoadingIndicator: true,
        gradeindex: 0,
        grade: '',
        csize: '',
        numTypeName: '身份证',
        numtype: 1,
        kaoji_id: this.$route.query.kaoji_id,
        share_id: this.$route.query.share_id,
        name: '',
//                    num:'362323198807150036',
//                    pic:[{"uid":"vc-upload-1588058680174338","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-28/1588058680174338.png","name":" bg-doing.png","save_name":"h5/2020-04-28/1588058680174338.png"}],
        pic: [],
//                    height:1,
//                    weight:2,
//                    footsize:3,
//                    famliy_name:'李',
//                    famliy_num:'320101197301011111',
//                    phone:'15177772222',
      },
      numTypeColumns: ['身份证', '护照'],
      row: {},
      warnings: [],
      starType: '',
      saveLoading: false,

    };
  },
  watch: {},

  filter: {},
  mounted() {
    document.title = "申报考级";
    this.fetch();
  },
  destroyed() {
  },
  methods: {
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.numtype = index + 1;
      this.showNumTypePicker = false;
    },
    onGradeConfirm(value, index) {
      this.formData.grade = value;
      this.formData.gradeindex = index + 1;
      this.showGradePicker = false;
    },
    onLiankaoChange(value) {
      console.log(value)
      if(value) {
        this.gradeSelectColumns = this.gradeLiankaoColumns
      } else {
        this.gradeSelectColumns = this.gradeColumns
      }
    },
    fetch() {
      let that = this;
      that.$api.get('/api/qcxj/kaojiJoinDetailNew', {
        kaoji_id: that.kaoji_id,
        share_id: that.share_id,
      }, (res) => {
        let starType = ''
        res.data.star_type.map(row => {
          starType = starType.concat(row + ' ')
        })

        console.log('star', starType)
        that.starType = starType;
        that.row = res.data;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    submitForm2(formName) {

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          // if (that.formData.heying.length == 0) {
          //   this.$message.warning('请上传队伍照片');
          //   return
          // }
          for (let field in that.formData) {

          }
          that.saveLoading = true;

          that.$api.post('/api/qcxj/checkApplyNameNum', {
            name: that.formData.name,
            num: that.formData.num,
            numtype: that.formData.numtype,
          }, (res) => {
            if (res.data) {
              that.formData.height = res.data.height;
              that.formData.weight = res.data.weight;
              that.formData.footsize = res.data.footsize;
              that.formData.pic = res.data.pic;
              that.formData.famliy_name = res.data.famliy_name;
              that.formData.famliy_num = res.data.famliy_num;
              that.formData.phone = res.data.phone;
            }
            that.isSubmit = true;
            that.saveLoading = false;
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });


    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/qcxj/checkApplyNameNum', {
        name: that.formData.name,
        num: that.formData.num,
        numtype: that.formData.numtype,
      }, (res) => {
        if (res.data) {
          that.formData.height = res.data.height;
          that.formData.weight = res.data.weight;
          that.formData.footsize = res.data.footsize;
          that.formData.pic = res.data.pic;
          that.formData.famliy_name = res.data.famliy_name;
          that.formData.famliy_num = res.data.famliy_num;
          that.formData.phone = res.data.phone;
        }
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        that.$message.warning(res.msg);
        that.saveLoading = false;
      })
    },

    picShow(index, list) {
      ImagePreview({
        images: list,
        startPosition: index,
      });
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onConfirm(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if (that.formData.pic.length == 0) {
          that.$message.warning('请上传证件照');
          return
        }
        if (!that.formData.grade) {
          that.$message.warning('请选择星级');
          return
        }
      }
      this.confirmShow = true;
    },

    submitForm(formName) {

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          for (let field in that.formData) {
            // if(that.formData.pic.length==0){
            //     Toast.fail('请上传证件照');
            //     return
            // }
            if (!that.formData.grade) {
              this.$message.warning('请选择星级');
              return
            }
          }
          that.saveLoading = true;
          that.$api.post('/api/qcxj/applyMemberAddSimple', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('报名成功');

            setTimeout(function () {
              rbLink({
                name: '',
                query: {}
              }, 'back')

            }, 500);

          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });


    },

    onConfirmSubmit() {
      let that = this;
      that.saveLoading = true;
      that.$api.post('/api/qcxj/applyMemberAdd', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('报名成功');

        setTimeout(function () {
          rbLink({
            name: '',
            query: {}
          }, 'back')

        }, 500);

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
};
</script>



// WEBPACK FOOTER //
// ExameApplyMemberAdd.vue?6e4ef316